import type { FC } from "react"
import "./styles.css"

interface SwimIconProps {
  className?: string
  fill?: string
  width?: string | number
  height?: string | number
  "aria-label"?: string
  role?: string
}

export const SwimIcon: FC<SwimIconProps> = ({ className, fill, width, height, "aria-label": ariaLabel, role }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={width || "19"}
    height={height || "12"}
    viewBox="0 0 19 12"
    fill={fill ? fill : "#BAFD4F"}
    aria-label={ariaLabel}
    role={role}
  >
    <path d="M1.44059 11.4C1.11059 11.4 0.790594 11.22 0.620594 10.91C0.380594 10.46 0.550595 9.89 1.00059 9.65L4.60059 7.72C5.55059 7.21 6.68059 7.21 7.64059 7.7L10.1806 9.02C10.6206 9.25 11.1506 9.23 11.5706 8.96L13.3106 7.86C14.2706 7.26 15.4906 7.2 16.5006 7.7L17.8306 8.37C18.2906 8.6 18.4806 9.16 18.2506 9.62C18.0206 10.08 17.4606 10.27 17.0006 10.04L15.6706 9.37C15.2406 9.15 14.7106 9.18 14.3006 9.44L12.5606 10.54C11.5906 11.15 10.3506 11.2 9.32059 10.67L6.78059 9.35C6.37059 9.14 5.88059 9.14 5.48059 9.35L1.88059 11.28C1.74059 11.35 1.59059 11.39 1.44059 11.39V11.4Z" />
    <path d="M14.681 6.6C14.681 6.6 12.371 6.98 11.111 8.18C10.921 8.36 10.631 8.4 10.391 8.27C9.71095 7.9 8.88095 6.8 6.35095 6.75C5.95095 6.75 5.82095 6.22 6.16095 6.01L9.46095 4.03L8.05095 2.54L5.08095 4.41C4.65095 4.68 4.07095 4.55 3.80095 4.12C3.53095 3.69 3.66095 3.11 4.09095 2.84L7.71095 0.559997C8.09095 0.319997 8.58095 0.379996 8.88095 0.709996L11.301 3.28L14.691 6.61L14.681 6.6Z" />
    <path d="M14.4712 4.38C15.4046 4.38 16.1612 3.62336 16.1612 2.69C16.1612 1.75664 15.4046 1 14.4712 1C13.5379 1 12.7812 1.75664 12.7812 2.69C12.7812 3.62336 13.5379 4.38 14.4712 4.38Z" />
  </svg>
)
